import { useState, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { IoClose, IoCheckmarkSharp } from "react-icons/io5";

export default function PhotoEditorModal({ file, onClose, onSave }) {
    const [imageSrc, setImageSrc] = useState(null);
    const [crop, setCrop] = useState(null);
    const [imageRef, setImageRef] = useState(null);

    // Load selected image
    useEffect(() => {
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => setImageSrc(reader.result);
        reader.readAsDataURL(file);
    }, [file]);

    // Create centered square crop on image load
    function onImageLoad(e) {
        const img = e.currentTarget;
        setImageRef(img);

        const { width, height } = img;

        const size = Math.min(width, height) * 0.6; // 60% of shorter side

        const x = (width - size) / 2;
        const y = (height - size) / 2;

        setCrop({
            unit: "px",
            width: size,
            height: size,
            x,
            y,
            aspect: 1,
        });
    }

    // Generate cropped image blob
    async function getCroppedImage() {
        if (!imageRef || !crop?.width) return;

        const canvas = document.createElement("canvas");
        const scaleX = imageRef.naturalWidth / imageRef.width;
        const scaleY = imageRef.naturalHeight / imageRef.height;

        canvas.width = crop.width * scaleX;
        canvas.height = crop.height * scaleY;

        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            imageRef,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        return new Promise((resolve) => {
            canvas.toBlob((blob) => resolve(blob), "image/jpeg");
        });
    }

    const handleSave = async () => {
        const blob = await getCroppedImage();
        onSave(blob);
        onClose();
    };

    if (!imageSrc) return null;

    return (
        <div className="fixed inset-0 bg-black/95 z-50 flex flex-col items-center justify-center overflow-hidden">

            <div className="relative bg-[#666] p-4 rounded-md">
                <ReactCrop
                    crop={crop}
                    onChange={(c) => setCrop(c)}
                    aspect={1}
                    keepSelection
                >
                    <img
                        src={imageSrc}
                        onLoad={onImageLoad}
                        alt="Crop"
                        style={{ maxHeight: "70vh" }}
                    />
                </ReactCrop>
            </div>

            <div className="flex items-center gap-12 mt-10 text-white text-3xl">

                <button
                    onClick={onClose}
                    className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-black text-xl transition active:scale-90"
                >
                    <IoClose size={30} />
                </button>

                {/* VIDEO */}
                <button
                    onClick={handleSave}
                    className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-black text-xl transition active:scale-90"
                >
                    <IoCheckmarkSharp size={30} />
                </button>
            </div>
        </div>
    );
}